import toast from 'react-hot-toast';

import { Notification } from '@kc-console/common-ui';

import type { ToastOptions } from 'react-hot-toast';
import type { NotificationProps } from '@kc-console/common-ui';

export interface UseNotificationToastReturn {
  dismissNotification: (id: string) => void;
  enqueueNotification: (
    notificationProps: NotificationProps,
    toastOptions?: ToastOptions,
  ) => string;
}

export interface EnqueueNotificationParams {}
export const useNotificationToast = (): UseNotificationToastReturn => {
  const enqueueNotification = (
    notificationProps: NotificationProps,
    toastOptions?: ToastOptions,
  ) => {
    const { onClose, ...restNotificationProps } = notificationProps;
    const { duration = Infinity, ...restToastOptions } = toastOptions || {};

    return toast.custom(
      t => (
        <div
          style={{
            animation: t.visible
              ? 'slideInFromLeft 0.3s ease-out'
              : 'slideOutToRight 0.3s ease-in forwards',
          }}
        >
          <Notification
            onClose={() => {
              onClose?.();
              toast.dismiss(t.id);
            }}
            {...restNotificationProps}
          />
        </div>
      ),
      {
        duration,
        ...restToastOptions,
      },
    );
  };

  const dismissNotification = (id: string) => {
    toast.dismiss(id);
  };

  return {
    enqueueNotification,
    dismissNotification,
  };
};
